
import { useEffect, useRef, useState } from 'react';
import styles from './details.module.css'
// import { submitScore } from '../../services/scoreService';
const options = ["js", "python"];

export default function Details({ onSelect }) {
    const [mode, setMode] = useState(null); // "js" | "python"
    const audioRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(null);

    useEffect(() => {
        setTimeout(() => {
            setSelectedIndex(0);

            // test.forEach(async (obj, index) => {
            //     // Add a unique index to the email
            //     obj.email = `test+${index}@qodo.ai`;
            //     await submitScore(obj);
            // });
        }, 1000);
    }, []);
    useEffect(() => {
        if (mode) {
            onSelect({ mode })
        }
    }, [mode]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (mode) return;

            if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                setSelectedIndex((prev) => (prev + 1) % options.length);
            } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                setSelectedIndex((prev) => (prev - 1 + options.length) % options.length);
            } else if (e.key === "Enter") {
                setMode(options[selectedIndex]);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [mode, selectedIndex]);

    return (
        <div className={styles.detailsContainer}>
            <div className={styles.starsWrap}>
                <div id='stars'></div>
                <div id='stars2'></div>
                <div id='stars3'></div>
            </div>
            <audio ref={audioRef} src="/sound/second.mp3" autoPlay loop />

            {!mode && (
                <>
                    <h2>CHOOSE YOUR LANGUAGE</h2>
                    <p className={styles.arrows}>
                        ← →
                    </p>
                    <div className={styles.options}>
                        {options.map((lang, index) => (
                            <div
                                onClick={() => {
                                    setMode(options[index]);
                                }}
                                key={lang}
                                className={`${styles.option} ${selectedIndex === index ? styles.selected : ''}`}
                            >
                                <img src={`/${lang}logo-pixel.png`} alt={lang} />
                            </div>
                        ))}
                    </div>


                </>
            )}
            <img
                src="qodo-back.png"
                className={`${styles.back} ${selectedIndex === 0 && !mode ? styles.enlarge : ""
                    }`}
            />

            <img
                src="qodo-hat.png"
                className={`${styles.hat} ${selectedIndex === 1 && !mode ? styles.enlarge : ""
                    }`}
            />
        </div>
    );
}